import { CustomContentsServant } from 'data-ng-custom-text';
import { ITermProgramInfoModel, TermProgramInfoModel } from '../term_courses/models/term_program_info_model';
import { ICommand } from 'core-ts-types';
import { TermScheduleFlags } from '../course_scheduler/services/term_schedule_flags';
import { RegisterSectionsQuery } from '../course_scheduler/queries/register_sections_query';
import { TermCourseQuery } from '../term_courses/queries/term_courses_query';
import { SchedulerModel } from '../course_scheduler/models/scheduler_model';
import * as _4 from 'lodash4';
import { SchedulerCustomTextQuery } from '../course_scheduler/queries/scheduler_custom_text_query';
import { SearchAndCourseFeatureFacade } from '../../search_and_add_courses/facades/search_and_courses_feature_facade';

interface IRegistrationFlags {
  isSeatRefreshPusherInitiated: boolean;
  isOneClickRegistrationEnabled: boolean;
  isRegisterRequestPending: boolean;
}

interface IRegistrationModels {
  account: any;
  selectedCourse: any;
  sectionTypeName: string;
}

class Registration {
  private sectionLabel: string = 'Section';
  private SISURL: string = '';
  private termAndProgramInfo: ITermProgramInfoModel;
  private urls: {
    registration: string;
    submit: () => void;
  };
  private pins: {
    required: {};
  };
  private termId: number;
  private flags: IRegistrationFlags = {
    isSeatRefreshPusherInitiated: false,
    isOneClickRegistrationEnabled: this.ngTermScheduleFlags.isOneClickRegistrationEnabled(),
    isRegisterRequestPending: false
  };
  private models: IRegistrationModels = {
    account: {},
    selectedCourse: {},
    sectionTypeName: ''
  };

  private showTimelineCalendar: boolean = true;
  private isPreferencesModeActive: boolean = false;

  private institutionName: string = '';
  constructor(
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $timeout: ng.ITimeoutService,
    private $window: ng.IWindowService,
    private appConfigModel: any,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private studentAvailabilityDelegate: any,
    private loadStudentUnavailabilityCommand: ICommand,
    private ngTermScheduleFlags: TermScheduleFlags,
    private accountModel: any,
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngTermCourseQuery: TermCourseQuery,
    private ngSchedulerModel: SchedulerModel,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade
  ) {}
  $onInit() {
    this.init();
  }
  init() {
    this.sectionLabel = this.appConfigModel.model.member_configs['section_label'] || 'Section';
    this.SISURL = _4.get(this.ngSchedulerModel.read(), 'customtext.SIS_REGISTRATION_URL.text', '');
    this.termAndProgramInfo = this.ngTermProgramInfoModel.read();
    this.isPreferencesModeActive = false;
    this.institutionName = this.appConfigModel.model.member_configs['core-inst_name'];
    this.termId = this.$stateParams.termId;
    this.urls = {
      registration: '',
      submit: () => {
        this.$window.open(this.urls.registration);
      }
    };
    this.pins = {
      required: {}
    };
    this.flags = {
      isSeatRefreshPusherInitiated: false,
      isOneClickRegistrationEnabled: this.ngTermScheduleFlags.isOneClickRegistrationEnabled(),
      isRegisterRequestPending: false
    };

    this.models = {
      account: this.accountModel,
      selectedCourse: {},
      sectionTypeName: ''
    };

    this.$timeout(() => {
      angular.element('.focused').focus();
    }, 200);
    this.refreshSchedule();
  }

  $onChanges() {
    this.init();
  }

  print() {
    this.$window.print();
  }

  allCoursesSelected() {
    return this.ngTermCourseQuery.result.unscheduled.length === 0;
  }

  showPrintMessage() {
    return (
      this.allCoursesSelected() &&
      this.ngRegisterSectionsQuery.result.scheduledSections.length !== 0 &&
      !this.flags.isOneClickRegistrationEnabled &&
      !_4.isEmpty(this.ngSchedulerCustomTextQuery.result.SCH_REGISTRATION_PROMPT)
    );
  }

  goBackToTermCourses() {
    this.$state.go('my.schedule.registration', {}, { reload: 'my.schedule.registration' });
  }

  refreshSchedule() {
    this.loadStudentUnavailabilityCommand(this.$stateParams.termId);
    this.studentAvailabilityDelegate.save();
  }

  togglePrefMode() {
    this.isPreferencesModeActive = !this.isPreferencesModeActive;
  }
  toggleTimelineCalendar() {
    this.showTimelineCalendar = !this.showTimelineCalendar;
  }
}

angular.module('capability-ng-scheduler').component('schedulerRegistrationContainer', {
  templateUrl: 'capability-ng-scheduler/src/views/registration/registration_container.html',
  controller: Registration
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/registration_container.ts